export default __webpack_public_path__ + "static/media/mcdonalds-logo-meaning.1be1ef01.png";